
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro",
      function () {
        return require("private-next-pages/astro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astro"])
      });
    }
  